import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import Card from 'components/Card';
import { Link } from 'v3/components';

const innerCol = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
  overflowWrap: 'break-word',
  wordBreak: 'normal',
};

const innerColWithBorder = {
  ...innerCol,
  borderLeft: '1px solid #e0e0e0',
  paddingLeft: '12px',
};

const labelStyle = {
  display: 'block',
  marginBottom: '2px',
};

const valueStyle = {
  display: 'block',
  width: '100%',
  whiteSpace: 'normal',
  lineHeight: 1.5,
  overflowWrap: 'break-word',
  wordBreak: 'normal',
  marginBottom: '2px',
};

const gridItemStyle = {
  minWidth: 0,
  flexBasis: '16.666667%',
  maxWidth: '16.666667%',
};

const sectionDivider = {
  margin: '10px 0 6px',
};

const topSectionStyle = {
  minHeight: '96px',
  maxHeight: '96px',
  overflow: 'hidden',
};

const CardViagem = (props) => {
  function formatDate(date) {
    if (date === 'Invalid date') {
      return 'Não ocorreu';
    }
    return date;
  }

  function renderStepContent(step) {
    if (!step) {
      return (
        <Typography variant="body2" component="span" style={valueStyle}>
          Não ocorreu
        </Typography>
      );
    }
    return (
      <>
        <Typography variant="body2" component="span" style={valueStyle}>
          {formatDate(moment(step.date).format('DD/MM/YYYY HH:mm'))}
        </Typography>
        <Typography variant="body2" component="span" style={valueStyle}>
          {step.user}
        </Typography>
        <Typography variant="body2" component="span" style={valueStyle}>
          {step.user_type}
        </Typography>
      </>
    );
  }

  const steps = {};
  const { logs } = props.travel;

  logs.forEach((log) => {
    const status = log.obs?.split(' ');
    if (status) {
      const step = status[status.length - 1]
        .replace('.', '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

      steps[step] = {
        date: log.created_at,
        user: log.userCreated.username,
        user_type: log.userCreated.profile.name,
      };
    }
  });

  const lastStep = steps.cancelado ? (
    <>
      <Typography variant="caption" component="span" style={labelStyle}>
        <strong>Cancelado:</strong>
      </Typography>
      {renderStepContent(steps.cancelado)}
    </>
  ) : (
    <>
      <Typography variant="caption" component="span" style={labelStyle}>
        <strong>Finalizado:</strong>
      </Typography>
      {renderStepContent(steps.finalizado)}
    </>
  );

  return (
    <div>
      <Card style={{ marginBottom: '10px' }} bordered borderhexcolor={props.status_color}>
        <Grid container spacing={0}>

          {/* Coluna 1: ID Carga / Ordem de coleta */}
          <Grid item xs={6} md={2} style={gridItemStyle}>
            <div style={innerCol}>
            <div style={topSectionStyle}>
              <Typography variant="caption" component="span" style={labelStyle}>
                <strong>ID Carga:</strong>
              </Typography>
              <Link to={`/cargas/${props.travel.load_id}`} target="_blank" withoutIcon style={{ display: 'block' }}>
                <Typography variant="body2" component="span" style={valueStyle}>
                  {props.travel.load_id}
                </Typography>
              </Link>
            </div>

            <div style={sectionDivider} />

            <div>
              <Typography variant="caption" component="span" style={labelStyle}>
                <strong>Ordem de coleta:</strong>
              </Typography>
              <Typography variant="body2" component="span" style={valueStyle}>
                {formatDate(moment(props.travel.created_at).format('DD/MM/YYYY HH:mm'))}
              </Typography>
            </div>
            </div>
          </Grid>

          {/* Coluna 2: Número viagem / Carregamento */}
          <Grid item xs={6} md={2} style={gridItemStyle}>
            <div style={innerColWithBorder}>
            <div style={topSectionStyle}>
              <Typography variant="caption" component="span" style={labelStyle}>
                <strong>Número viagem:</strong>
              </Typography>
              <Link to={`/viagens/${props.travel.id}`} target="_blank" withoutIcon style={{ display: 'block' }}>
                <Typography variant="body2" component="span" style={valueStyle}>
                  {props.travel.id}
                </Typography>
              </Link>
            </div>

            <div style={sectionDivider} />

            <div>
              <Typography variant="caption" component="span" style={labelStyle}>
                <strong>Carregamento:</strong>
              </Typography>
              {renderStepContent(steps.carregamento)}
            </div>
            </div>
          </Grid>

          {/* Coluna 3: ID Externo / Emissão */}
          <Grid item xs={6} md={2} style={gridItemStyle}>
            <div style={innerColWithBorder}>
            <div style={topSectionStyle}>
              <Typography variant="caption" component="span" style={labelStyle}>
                <strong>ID Externo:</strong>
              </Typography>
              <Link to={`/viagens/${props.travel.id}`} target="_blank" withoutIcon style={{ display: 'block' }}>
                <Typography variant="body2" component="span" style={valueStyle}>
                  {props.travel.travel_number ? props.travel.travel_number : 'Não informado'}
                </Typography>
              </Link>
            </div>

            <div style={sectionDivider} />

            <div>
              <Typography variant="caption" component="span" style={labelStyle}>
                <strong>Emissão:</strong>
              </Typography>
              {renderStepContent(steps.emissao)}
            </div>
            </div>
          </Grid>

          {/* Coluna 4: Tomador - CNPJ / Descarregamento */}
          <Grid item xs={6} md={2} style={gridItemStyle}>
            <div style={innerColWithBorder}>
            <div style={topSectionStyle}>
              <Typography variant="caption" component="span" style={labelStyle}>
                <strong>Tomador - CNPJ:</strong>
              </Typography>
              <Link
                to={`/clientes/${props.travel.load.client.id}`}
                target="_blank"
                withoutIcon
                style={{ display: 'block' }}
              >
                <Typography variant="body2" component="span" style={valueStyle}>
                  {props.travel.load.client.social_name}
                </Typography>
                <Typography variant="body2" component="span" style={valueStyle}>
                  {props.travel.load.client.cgccpf}
                </Typography>
              </Link>
            </div>

            <div style={sectionDivider} />

            <div>
              <Typography variant="caption" component="span" style={labelStyle}>
                <strong>Descarregamento:</strong>
              </Typography>
              {renderStepContent(steps.descarregamento)}
            </div>
            </div>
          </Grid>

          {/* Coluna 5: Transportadora / Em análise */}
          <Grid item xs={6} md={2} style={gridItemStyle}>
            <div style={innerColWithBorder}>
            <div style={topSectionStyle}>
              <Typography variant="caption" component="span" style={labelStyle}>
                <strong>Transportadora:</strong>
              </Typography>
              <Link
                to={`/transportadoras/${props.travel.shipping_company}`}
                target="_blank"
                withoutIcon
                style={{ display: 'block' }}
              >
                <Typography variant="body2" component="span" style={valueStyle}>
                  {props.travel.shipper && props.travel.shipper.social_name}
                </Typography>
              </Link>
            </div>

            <div style={sectionDivider} />

            <div>
              <Typography variant="caption" component="span" style={labelStyle}>
                <strong>Em análise:</strong>
              </Typography>
              {renderStepContent(steps.analise)}
            </div>
            </div>
          </Grid>

          {/* Coluna 6: Motorista / Finalizado (ou Cancelado) + Documentos */}
          <Grid item xs={6} md={2} style={gridItemStyle}>
            <div style={innerColWithBorder}>
            <div style={topSectionStyle}>
              <Typography variant="caption" component="span" style={labelStyle}>
                <strong>Motorista:</strong>
              </Typography>
              <Link
                to={`/motoristas/${props.travel.driver_id}`}
                target="_blank"
                withoutIcon
                style={{ display: 'block' }}
              >
                <Typography variant="body2" component="span" style={valueStyle}>
                  {props.travel.driver.social_name}
                </Typography>
              </Link>
            </div>

            <div style={sectionDivider} />

            <div>
              {lastStep}

              {props.travel.att_user && (
                <>
                  <div style={sectionDivider} />
                  <Typography variant="caption" component="span" style={labelStyle}>
                    <strong>Documentos:</strong>
                  </Typography>
                  <Typography variant="body2" component="span" style={valueStyle}>
                    {formatDate(moment(props.travel.att_created).format('DD/MM/YYYY HH:mm'))}
                  </Typography>
                  <Typography variant="body2" component="span" style={valueStyle}>
                    {props.travel.att_user}
                  </Typography>
                </>
              )}
            </div>
            </div>
          </Grid>

        </Grid>
      </Card>
    </div>
  );
};

export default CardViagem;
